import Table from 'components/Table/TableStatic';
import TooltipIcon from 'components/Tooltip/TooltipIcon';
import Truncator from 'components/Truncator';
import {SendNotificationEmail} from 'pages/History/SendingOrders/Details/types';
import {FC} from 'react';
import {c, t} from 'ttag';

interface Props {
    sentEmailSet: SendNotificationEmail[];
}

const SentEmailTable: FC<Props> = ({sentEmailSet}) => {
    return (
        <Table classNameTable="table-fixed">
            <Table.Header>
                <Table.HeaderRow>
                    <Table.Column className="w-1/2">{c('supersend')
                        .t`Email`}</Table.Column>
                    <Table.Column className="flex w-1/2 items-center gap-2">
                        {t`Status`}
                        <TooltipIcon
                            href="https://help.makeleaps.jp/ja/articles/6046149-操作履歴-送付履歴を検索する#h_a4f7868c0a"
                            message={t`What is “Status”?`}
                            size="base"
                        />
                    </Table.Column>
                </Table.HeaderRow>
            </Table.Header>
            <Table.Body>
                {sentEmailSet.map((data) => (
                    <Table.Row key={data.mid}>
                        <Table.Cell>
                            <Truncator text={data.email} />
                        </Table.Cell>
                        <Table.Cell>
                            <Truncator text={data.displayStatus} />
                        </Table.Cell>
                    </Table.Row>
                ))}
            </Table.Body>
        </Table>
    );
};

export default SentEmailTable;
